function instafarm(){
  if($('.insta_images_card').length > 0 && $('.instagram-item').length > 0){
    setTimeout(function(){
      $('.insta_images_card').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        fade: false,
        dots: false,
        infinite: false,
        speed: 100,
        autoplay: false,
        swipeToSlide: true,
        autoplaySpeed: 3000,
        touchThreshold: 100,
        waitForAnimate: false,
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              swipeToSlide: true,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 641,
            settings: {
              slidesToShow: 1,
              swipeToSlide: true,
              slidesToScroll: 1
            }
          }
        ]
      });
    },500);
  }else{
    setTimeout(function(){
      instafarm();
    },200);
  }
}

setTimeout(function(){
  instafarm();
},500);

const slickDestroyBeforeLoad= ()=>{
  return new Promise((resolve,reject)=>{
    if($('.product-img-slider').hasClass('slick-initialized')){
      $('.product-img-slider').slick('destroy');
      $('.product-img-slider').css('opacity', 1);
      $('.product-img-slider').css('height','100%');
    }
    try{
      resolve();
    }catch(error){
      reject(error);
    }
  });
}

const pimgsMob = () => {
  const pr1 = slickDestroyBeforeLoad();
  pr1.then(()=>{
    //console.log('before slick');
    $('.product-img-slider').slick({
      slidesToShow: 1.1,
      slidesToScroll: 1,
      slidesPerRow: 1,
      vertical: false,
      verticalSwiping: false,
      swipeToSlide: true,
      adaptiveHeight: true,
      infinite: false,
      dots: true,
      arrows: false
    });
  })
}

const setImageContainerSize = () => {
  if (window.innerWidth < 641) {
    $('.product-img-view').css('height','100%');
    $('.product-img-view .pdpimg_loader').css('display','none');
    $('.product-img-slider.new_custom_imgs').css('display','flex');
  } else {
    $(".product-img-view").css("height", $(".pr-all-dt-inner").outerHeight() + 100);
    $('.product-img-slider.new_custom_imgs').css('height','');
    $('.product-img-slider.new_custom_imgs').css('display','grid');
  }
}

window.addEventListener('load', (event) => {
  if ($('.product-img-slider').length > 0 ) {
    if($('.option_Color input').length > 0){
      if ($('.option_Color .available input:checked').length > 0) {
        var val = $('.option_Color .available input:checked').val().toLowerCase();
      } else {
        var val = $('.option_Color .available input').first().val().toLowerCase();
      }
      if($('.product-img-slider.color_' + val).length > 0){
        $('.product-img-slider.color_' + val).hide();
        $('.product-img-slider.color_' + val).show();
      }else{
        $('.product-img-slider').show();
      }
    }else{
      $('.product-img-slider').show();
    }

    setTimeout(function () {
      if (window.innerWidth < 641) {
        pimgsMob();
      }
      setImageContainerSize();
    }, 400);
  }
});



$(window).resize(function () {
  if($('.product-img-slider').hasClass('slick-initialized')){
    $('.product-img-slider').slick('destroy');
  }
});

$(window).on('load resize orientationchange', function () {
  $('.pdp_img_inner').each(function () {
    var $pdp_img_inner = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    if (window.innerWidth > 640) {
      if ($pdp_img_inner.hasClass('slick-initialized')) {
        $pdp_img_inner.slick('unslick');
      }
    } else {
      if (!$pdp_img_inner.hasClass('slick-initialized')) {
        $pdp_img_inner.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          infinite: false,
          dots: true,
          touchThreshold: 100,
          swipeToSlide: true,
          waitForAnimate: false
        });
      }
    }
  });

  setImageContainerSize();

  if (window.innerWidth < 641) {
    pimgsMob();
  }

});


